import { sdk } from '@service/http/axios'
export default sdk
